import { SEARCH_MVT_FEATURE_NAME } from "../constants";
import { SEARCH_MVT_FLAG_NAME } from "../../lib/api/constants";
import activateMvtFeature from "../../client/activateMvtFeature";

const activateSearchMvt = mvtParams => {
  if (!mvtParams[SEARCH_MVT_FLAG_NAME]) {
    return;
  }

  activateMvtFeature(SEARCH_MVT_FEATURE_NAME);
};

export default activateSearchMvt;
